import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=395aecd6&scoped=true&"
import script from "./queue.vue?vue&type=script&lang=js&"
export * from "./queue.vue?vue&type=script&lang=js&"
import style0 from "./queue.vue?vue&type=style&index=0&id=395aecd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395aecd6",
  null
  
)

export default component.exports